




























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import currencies from '@/data/currencies'
import IAccount from '@/models/IAccount'
import ICurrency from '@/models/ICurrency'
import accountService from '@/services/AccountService'
import queueNotifService from '@/services/QueueNotifService'
import IUser from '@/models/IUser'
import { slug } from '@/utils'

@Component({
  components: {
    'color-picker': () => import('@/components/ColorPicker.vue'),
    'account-user-new': () => import('@/components/AccountUserNew.vue')
  }
})
export default class AccountNew extends Vue {
  @Getter
  public user!: IUser | null
  public name: string = ''
  public currencies: ICurrency[] = currencies
  public mainCurrency: ICurrency = currencies[0]
  public accountCurrencies: ICurrency[] = [currencies[0]]
  public color: string | null = null
  public users: IUser[] = []
  public currencyShow: boolean = false
  public isPublic: boolean = false

  public mounted(): void {
    if (this.user && !this.user.alias) {
      this.user.alias = this.user.userId
    }
  }

  public toggleCurrencyShow(): void {
    this.currencyShow = !this.currencyShow
  }

  public validate(users: IUser[]): boolean {
    if (!this.name) {
      queueNotifService.error('Le nom doit être rempli.')
      return false
    }
    const aliases: string[] = users.map((user: IUser) =>
      user.alias ? user.alias.toLowerCase() : ''
    )
    if (aliases.length === 0) {
      queueNotifService.error(
        'Au moins une personne doit être ajoutée au compte.'
      )
      return false
    }
    if (aliases.length !== new Set(aliases).size) {
      queueNotifService.error('Les alias doivent être uniques.')
      return false
    }

    if (this.user) {
      const userIds: string[] = users.map((user: IUser) => user.userId)
      if (userIds.length !== new Set(userIds).size) {
        queueNotifService.error('Les identifiants doivent être uniques.')
        return false
      }
    }

    return true
  }

  public async submitAccount(): Promise<void> {
    let users: IUser[] = this.user ? [this.user, ...this.users] : this.users
    if (!this.validate(users)) {
      return
    }
    users = users.map((u: IUser) => ({
      userId: u.userId,
      email: u.email,
      slugEmail: u.slugEmail,
      premium: u.premium,
      alias: u.alias,
      firstname: u.firstname,
      lastname: u.lastname
    }))
    const userIds: string[] = users.map((u: IUser) => slug(u.userId))
    const newAccount: IAccount = {
      doctype: 'account',
      name: this.name,
      admin: this.user
        ? {
            userId: this.user.userId,
            email: this.user.email,
            slugEmail: this.user.slugEmail,
            premium: this.user.premium,
            alias: this.user.alias,
            firstname: this.user.firstname,
            lastname: this.user.lastname
          }
        : null,
      color: this.color,
      users,
      userIds,
      mainCurrency: this.mainCurrency,
      currencies: this.accountCurrencies,
      isPublic: this.isPublic
    }
    const response: PouchDB.Core.Response = await accountService.add(newAccount)
    if (response.ok) {
      this.$router.push({ name: 'account', params: { id: response.id } })
    } else {
      // tslint:disable-next-line:no-console
      console.warn(response)
      queueNotifService.error(
        `Une erreur s'est produite à la création d'un compte.`
      )
    }
  }

  @Watch('mainCurrency', { immediate: true })
  public onMainCurrencyChange(
    currency: ICurrency,
    oldCurrency: ICurrency
  ): void {
    if (oldCurrency) {
      this.accountCurrencies = this.accountCurrencies.filter(
        (c: ICurrency) => c.code !== oldCurrency.code
      )
    }
    const cur: ICurrency | undefined = this.currencies.find(
      (c: ICurrency) => c.code === currency.code
    )
    if (cur) {
      const already: ICurrency | undefined = this.accountCurrencies.find(
        (c: ICurrency) => c.code === cur.code
      )
      if (!already) {
        this.accountCurrencies.push(cur)
      }
    }
  }
}
